import { createStore, applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import userReducer from "./reducer/userReducer";
import leadReducer from "./reducer/leadReducer";
import commonReducer from "./reducer/commonReducer";

const mainReducer = combineReducers({
  user: userReducer,
  lead: leadReducer,
  common: commonReducer,
});

const store = createStore(mainReducer, applyMiddleware(thunk));

export default store;
